@for (
  selectedCondition of existingConditions;
  track selectedCondition;
  let i = $index
) {
  <div class="filters">
    <app-automation-condition-builder-item
      [hideAddRemove]="hideAddRemove"
      [selectedCondition]="selectedCondition"
      [availableConditions]="availableConditions"
      [index]="i"
      [conjunction]="conjunction"
      (delete)="deleteFilter(i)"
      (addSubCondition)="addSubCondition(selectedCondition)"
    >
    </app-automation-condition-builder-item>
    @if (selectedCondition.isSubFilterAdded) {
      <div class="sub-conditions">
        @for (
          selectedSubCondition of selectedCondition.selectedSubConditions;
          track selectedSubCondition;
          let i = $index
        ) {
          <div class="filters">
            <app-automation-condition-builder-item
              [isSubCondition]="true"
              [hideAddRemove]="hideAddRemove"
              [selectedCondition]="selectedSubCondition"
              [availableConditions]="selectedCondition.filter.subConditionItems"
              [index]="i"
              (delete)="deleteSubFilter(selectedCondition, i)"
            >
            </app-automation-condition-builder-item>
          </div>
        }
        <button
          class="add-filter-button"
          mat-button
          color="primary"
          (click)="addSubCondition(selectedCondition)"
        >
          <mat-icon>add_circle</mat-icon> ADD SUB-CONDITION
        </button>
      </div>
    }
  </div>
}
@if (!hideAddRemove) {
  <button
    class="add-filter-button"
    mat-button
    color="primary"
    (click)="addCondition()"
  >
    + ADD CONDITION
  </button>
}
@if (showError) {
  <p
    class="error-message filter-panel-action-buttons"
    style="position: relative"
  >
    Please make sure to select all values, or remove the filter before applying.
  </p>
}
